import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { hasRole } from "@/js/http/auth";
import { formRules } from "@/js/form_rules.js";
import { formatPrice } from "@/js/currency/currencies.js";
import { filterVAutocomplete, getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import { getFullNameUser } from "@/js/user/user.js";
import { purchaseOrder, listUserGroups, stockReservationTypes } from "@/js/lists.ts";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import NewWineDialog from "@/components/products/NewWineDialog.vue";
import WineSupplierPriceModal from "@/components/supplier-prices/WineSupplierPriceModal.vue";
import PurchaseOrderStocksModal from "@/components/purchase-orders/PurchaseOrderStocksModal.vue";
import PurchaseOrderItemsQuantitiesOrderTable from "@/components/purchase-orders/PurchaseOrderItemsQuantitiesOrderTable.vue";
import PurchaseOrderItemsReservationTable from "@/components/purchase-orders/PurchaseOrderItemsReservationTable.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
export default {
  components: {
    Confirm: Confirm,
    PurchaseOrderItemsQuantitiesOrderTable: PurchaseOrderItemsQuantitiesOrderTable,
    PurchaseOrderItemsReservationTable: PurchaseOrderItemsReservationTable,
    NewWineDialog: NewWineDialog,
    WineSupplierPriceModal: WineSupplierPriceModal,
    PurchaseOrderStocksModal: PurchaseOrderStocksModal,
    ErrorModal: ErrorModal
  },
  props: {
    items: [],
    isLoadingOptions: Boolean,
    options: [],
    countries: [],
    disabled: Boolean,
    supplierId: Number,
    warehouse: Object,
    isStoredAtSupplier: Boolean,
    isReadOnly: Boolean,
    loggedUserData: Object,
    producerId: Number,
    dbPurchaseOrder: Object
  },
  data: function data(_this) {
    var _this$options$find;
    return {
      canManageSupplierPrices: false,
      isSaving: false,
      isLoadingStocks: false,
      form: {
        valid: false
      },
      isThereNewCogs: false,
      isFromWarehouseStock: false,
      warehouseStocksAvailableForItem: [],
      isFillingOrders: false,
      ordersFillableForItem: [],
      availableFillingOrdersCanBeDbUnsynced: false,
      isOverrideStockReservationType: false,
      gettingUserList: {
        isPending: false,
        cancellationToken: null,
        results: []
      },
      gettingConsultantList: {
        isPending: false,
        cancellationToken: null,
        results: []
      },
      gettingSupplierPrices: {
        isPending: false,
        cancellationToken: null,
        results: []
      },
      creatingAllPreArrivalStocks: {
        isPending: false,
        cancellationToken: null
      },
      dialog: false,
      dialogDelete: false,
      newWineModalShown: false,
      headers: [{
        text: "Name",
        value: "name"
      }, {
        text: "SKU",
        value: "sku"
      }, {
        text: "Fill",
        value: "fill",
        sortable: false
      }, {
        text: "Quantity",
        value: "quantity"
      }, {
        text: "Rate ex.vat",
        value: "rate",
        align: "center"
      }, {
        text: "Amount ex.vat",
        value: "amount",
        align: "center"
      }, {
        text: "Pre-arrival",
        value: "stock",
        sortable: false
      }, {
        text: "Actions",
        value: "actions",
        sortable: false
      }],
      selectedItems: [],
      editedItem: {
        wineId: 0,
        name: "",
        hasStocks: false,
        quantity: 0,
        rate: 0,
        amount: 0,
        newCogs: 0,
        sku: "",
        skuSuffix: "",
        intendedCountryIds: [],
        accountancyCode: (_this$options$find = _this.options.find(function (x) {
          var _this$editedItem;
          return x.wineId === ((_this$editedItem = _this.editedItem) === null || _this$editedItem === void 0 ? void 0 : _this$editedItem.wineId);
        })) === null || _this$options$find === void 0 ? void 0 : _this$options$find.accountancyCode,
        fromWarehouseStockId: null,
        fromWarehouseStock: null,
        quantitiesForOrders: [],
        reservations: []
      },
      defaultItem: {},
      isCheckingOrdersFillable: false,
      ordersFillableResponse: null,
      isWineSupplierPriceModalShown: false,
      currentWineId: null,
      isPurchaseOrderStocksModalShown: false,
      rules: formRules,
      stockReservationTypes: stockReservationTypes,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    allCountriesSelected: function allCountriesSelected() {
      return this.editedItem.intendedCountryIds.length === this.countries.length;
    },
    someCountriesSelected: function someCountriesSelected() {
      return this.editedItem.intendedCountryIds.length > 0 && !this.allCountriesSelected;
    },
    icon: function icon() {
      if (this.allCountriesSelected) return "mdi-close-box";
      if (this.someCountriesSelected) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    formTitle: function formTitle() {
      return this.editedItem.wineId ? "Edit Item" : "New Item";
    },
    isWarehouseStocksAvailableForItem: function isWarehouseStocksAvailableForItem() {
      var _this$editedItem2, _this$warehouseStocks, _this$editedItem3;
      return ((_this$editedItem2 = this.editedItem) === null || _this$editedItem2 === void 0 ? void 0 : _this$editedItem2.quantity) > 0 && ((_this$warehouseStocks = this.warehouseStocksAvailableForItem) === null || _this$warehouseStocks === void 0 ? void 0 : _this$warehouseStocks.length) > 0 && ((_this$editedItem3 = this.editedItem) === null || _this$editedItem3 === void 0 ? void 0 : _this$editedItem3.wineId) && !this.isStoredAtSupplier;
    },
    isOrdersFillableForItem: function isOrdersFillableForItem() {
      var _this$editedItem4, _this$ordersFillableF, _this$editedItem5;
      return ((_this$editedItem4 = this.editedItem) === null || _this$editedItem4 === void 0 ? void 0 : _this$editedItem4.quantity) > 0 && ((_this$ordersFillableF = this.ordersFillableForItem) === null || _this$ordersFillableF === void 0 ? void 0 : _this$ordersFillableF.length) > 0 && ((_this$editedItem5 = this.editedItem) === null || _this$editedItem5 === void 0 ? void 0 : _this$editedItem5.wineId) && !this.isStoredAtSupplier;
    },
    editedItemDbCogs: function editedItemDbCogs() {
      var _this2 = this;
      return !!this.editedItem.wineId ? this.options.find(function (x) {
        return x.wineId == _this2.editedItem.wineId;
      }).rate : null;
    },
    defaultReservationLabel: function defaultReservationLabel() {
      var _this$warehouse,
        _this3 = this;
      if (!!((_this$warehouse = this.warehouse) !== null && _this$warehouse !== void 0 && _this$warehouse.id_warehouse)) {
        var label = "Default warehouse stock reservation : ";
        label += Object.values(stockReservationTypes).find(function (x) {
          return x.id == _this3.warehouse.default_stock_reservation_type;
        }).name;
        if (!!this.warehouse.default_stock_reservation_user_id) {
          if (!!this.gettingUserList.results.length) {
            var _ref, _this$gettingUserList;
            label += (_ref = " " + ((_this$gettingUserList = this.gettingUserList.results.find(function (x) {
              return x.id == _this3.warehouse.default_stock_reservation_user_id;
            })) === null || _this$gettingUserList === void 0 ? void 0 : _this$gettingUserList.full_name)) !== null && _ref !== void 0 ? _ref : " (user#".concat(this.warehouse.default_stock_reservation_user_id, ")");
          } else {
            label += " (loading user data)";
          }
        } else if (!!this.warehouse.default_stock_reservation_consultant_id) {
          if (!!this.gettingConsultantList.results.length) {
            var _ref2, _this$gettingConsulta;
            label += (_ref2 = " " + ((_this$gettingConsulta = this.gettingConsultantList.results.find(function (x) {
              return x.id == _this3.warehouse.default_stock_reservation_consultant_id;
            })) === null || _this$gettingConsulta === void 0 ? void 0 : _this$gettingConsulta.full_name)) !== null && _ref2 !== void 0 ? _ref2 : " (user#".concat(this.warehouse.default_stock_reservation_consultant_id, ")");
          } else {
            label += " (loading consultant data)";
          }
        }
        return label;
      }
      return null;
    },
    isEditingPo: function isEditingPo() {
      var _this$dbPurchaseOrder;
      return +((_this$dbPurchaseOrder = this.dbPurchaseOrder) === null || _this$dbPurchaseOrder === void 0 ? void 0 : _this$dbPurchaseOrder.id) > 0;
    },
    isCancelledPo: function isCancelledPo() {
      return this.isEditingPo && this.dbPurchaseOrder.status === purchaseOrder.status.CANCELLED;
    },
    isReceivedPo: function isReceivedPo() {
      return this.isEditingPo && this.dbPurchaseOrder.receiptStatus === purchaseOrder.receiptStatus.RECEIVED;
    }
  },
  created: function created() {
    var _this4 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this4.canManageSupplierPrices = hasRole(process.env.VUE_APP_ROLES_MANAGE_SUPPLIER_PRICES);
            _this4.defaultItem = _objectSpread({}, _this4.editedItem);
            _this4.fetchAllWinesStock();
            _this4.fetchAllWinesSupplierPrices();
            _this4.getUserList();
            _this4.getConsultantList();
            _this4.getWarehouseStocksAvailableForItem();
            if (!_this4.disabled) {
              _this4.checkOrdersFillable();
            }
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    updateSkuSuffix: function updateSkuSuffix() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var response, stocks, stock;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this5.editedItem.skuSuffix = _this5.editedItem.skuSuffix.toUpperCase();
              _this5.editedItem.sku = "".concat(_this5.editedItem.accountancyCode).concat(_this5.editedItem.skuSuffix);
              _this5.editedItem.hasStocks = false;
              _this5.isLoadingStocks = true;
              _context2.next = 6;
              return request("/v1/stocks", "post", {
                label: _this5.editedItem.sku
              }, true, "api");
            case 6:
              response = _context2.sent;
              stocks = response.data.stocks;
              if (stocks !== null && stocks !== void 0 && stocks.length) {
                stock = stocks.find(function (x) {
                  return x.reference_warehouse === _this5.editedItem.sku && x.warehouse.id_warehouse === _this5.warehouse.id_warehouse;
                });
                if (stock) {
                  _this5.editedItem.intendedCountryIds = _toConsumableArray(stock.countries.map(function (x) {
                    return x.id_country;
                  }));
                  _this5.editedItem.hasStocks = true;
                }
              }
              _this5.isLoadingStocks = false;
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    assignAllCountries: function assignAllCountries() {
      this.editedItem.intendedCountryIds = _toConsumableArray(this.countries.map(function (x) {
        return x.id_country;
      }));
    },
    assignWarehouseDefaultCountries: function assignWarehouseDefaultCountries() {
      this.editedItem.intendedCountryIds = _toConsumableArray(this.warehouse.defaultIntendedCountries.map(function (x) {
        return x.id;
      }));
    },
    changeNewCogs: function changeNewCogs(value) {
      if (!value) this.editedItem.newCogs = null;
    },
    changeFillingOrders: function changeFillingOrders(value) {
      if (!value) this.editedItem.quantitiesForOrders = [];
    },
    changeOverrideStockReservationType: function changeOverrideStockReservationType(value) {
      if (!value) this.editedItem.reservations = [];
    },
    toggle: function toggle() {
      var _this6 = this;
      this.$nextTick(function () {
        if (_this6.allCountriesSelected) {
          _this6.editedItem.intendedCountryIds = [];
        } else {
          _this6.assignAllCountries();
        }
      });
    },
    changeQuantity: function changeQuantity(value) {
      if (this.isFillingOrders) {
        var sumQuantitiesForOrders = this.editedItem.quantitiesForOrders.reduce(function (acc, x) {
          return acc += x.quantity;
        }, +0);
        if (sumQuantitiesForOrders > +value) {
          this.editedItem.quantity = sumQuantitiesForOrders;
          this.$toasted.show("Not enough quantity to fill orders");
          return;
        }
      }
      var amount = value * this.editedItem.rate;
      this.editedItem = _objectSpread(_objectSpread({}, this.editedItem), {}, {
        quantity: value,
        amount: amount ? amount.toFixed(2) : 0
      });
    },
    changeRate: function changeRate(value) {
      var amount = value * this.editedItem.quantity;
      this.editedItem = _objectSpread(_objectSpread({}, this.editedItem), {}, {
        rate: value,
        amount: amount ? amount.toFixed(2) : 0
      });
    },
    changeItem: function changeItem(value) {
      var obj = this.options.find(function (x) {
        return x.wineId == value;
      });
      this.editedItem = _objectSpread(_objectSpread({}, this.editedItem), obj);
      this.changeRate(this.editedItem.rate);
      this.resetWarehouseStocks();
      this.getWarehouseStocksAvailableForItem();
      this.resetQuantitiesForOrders();
      this.getOrdersFillableForItem();
      this.updateSkuSuffix();
    },
    editItem: function editItem(item) {
      var _this$editedItem$quan, _this$editedItem$rese;
      this.editedItem = _objectSpread(_objectSpread({}, item), {}, {
        isBeingEdited: true
      });
      this.isFromWarehouseStock = this.editedItem.fromWarehouseStockId > 0;
      this.getWarehouseStocksAvailableForItem();
      this.getOrdersFillableForItem();
      this.updateSkuSuffix();
      this.isThereNewCogs = !!item.newCogs;
      this.isFillingOrders = ((_this$editedItem$quan = this.editedItem.quantitiesForOrders) === null || _this$editedItem$quan === void 0 ? void 0 : _this$editedItem$quan.length) > 0;
      this.isOverrideStockReservationType = ((_this$editedItem$rese = this.editedItem.reservations) === null || _this$editedItem$rese === void 0 ? void 0 : _this$editedItem$rese.length) > 0;
      this.dialog = true;
    },
    save: function save() {
      var _this7 = this;
      this.isSaving = true;
      var editedIndex = this.selectedItems.findIndex(function (x) {
        return _this7.editedItem.id > 0 && x.id === _this7.editedItem.id || x.wineId === _this7.editedItem.wineId && x.sku === _this7.editedItem.sku;
      });
      if (this.editedItem.isBeingEdited || editedIndex > -1) {
        this.selectedItems.splice(editedIndex, 1, _objectSpread({}, this.editedItem));
      } else {
        this.selectedItems = [].concat(_toConsumableArray(this.selectedItems), [_objectSpread({}, this.editedItem)]);
      }
      this.close();
      this.editedItem = _objectSpread({}, this.defaultItem);
      this.$emit("save", this.selectedItems);
      this.isSaving = false;
      this.fetchAllWinesSupplierPrices();
    },
    close: function close() {
      var _this8 = this;
      this.dialog = false;
      this.$nextTick(function () {
        _this8.editedItem = _objectSpread({}, _this8.defaultItem);
        _this8.isThereNewCogs = false;
        _this8.isFillingOrders = false;
      });
    },
    deleteItem: function deleteItem(item) {
      this.editedItem = item;
      this.dialogDelete = true;
    },
    deleteItemConfirm: function deleteItemConfirm() {
      this.selectedItems.splice(this.selectedItems.indexOf(this.editedItem), 1);
      this.closeDelete();
      this.$emit("save", this.selectedItems);
    },
    closeDelete: function closeDelete() {
      var _this9 = this;
      this.dialogDelete = false;
      this.$nextTick(function () {
        _this9.editedItem = _objectSpread({}, _this9.defaultItem);
      });
    },
    aggregateItem: function aggregateItem(a, b) {
      var quantity = +a.quantity + +b.quantity;
      var amount = (+a.amount + +b.amount).toFixed(2);
      return _objectSpread(_objectSpread({}, a), {}, {
        quantity: quantity,
        amount: amount
      });
    },
    resetWarehouseStocks: function resetWarehouseStocks() {
      var _this$editedItem6;
      if ((_this$editedItem6 = this.editedItem) !== null && _this$editedItem6 !== void 0 && _this$editedItem6.wineId) {
        this.editedItem.fromWarehouseStockId = null;
        this.editedItem.fromWarehouseStock = null;
        this.isFromWarehouseStock = false;
        this.warehouseStocksAvailableForItem = [];
      }
    },
    changeFromWarehouseStock: function changeFromWarehouseStock(value) {
      if (!value) {
        this.editedItem.fromWarehouseStock = null;
        this.editedItem.fromWarehouseStockId = null;
      }
    },
    changeFromWarehouseStockId: function changeFromWarehouseStockId(value) {
      var _this$warehouseStocks2;
      this.editedItem.fromWarehouseStock = (_this$warehouseStocks2 = this.warehouseStocksAvailableForItem) === null || _this$warehouseStocks2 === void 0 ? void 0 : _this$warehouseStocks2.find(function (x) {
        return x.id_stock === value;
      });
    },
    getWarehouseStocksAvailableForItem: function getWarehouseStocksAvailableForItem() {
      var _this$editedItem7,
        _this$warehouse2,
        _this10 = this;
      if (!((_this$editedItem7 = this.editedItem) !== null && _this$editedItem7 !== void 0 && _this$editedItem7.wineId)) {
        this.resetWarehouseStocks();
      } else if (((_this$warehouse2 = this.warehouse) === null || _this$warehouse2 === void 0 ? void 0 : _this$warehouse2.id_warehouse) > 0) {
        var _this$warehouse3;
        var _this = this;
        var data = {
          wineId: _this.editedItem.wineId,
          arrivalWarehouseId: +((_this$warehouse3 = this.warehouse) === null || _this$warehouse3 === void 0 ? void 0 : _this$warehouse3.id_warehouse)
        };
        var paramsQuery = Object.encodeToUri(data);
        request("/v1/purchase-orders/warehouse-stocks-for-wine?params=".concat(paramsQuery), "get", null, true, "api").then(function (response) {
          if (response.data.value.length > 0) {
            _this.warehouseStocksAvailableForItem = response.data.value;
            _this.warehouseStocksAvailableForItem.forEach(function (x) {
              x._searchable_name = x.warehouse.name + " - " + x.quantity + " btl(s) available";
              if (x.reservation_type != stockReservationTypes.DEFAULT.id) {
                x._searchable_name += " - Reservation: " + _this10.getLabelReservation(x);
              }
            });
          } else {
            _this.warehouseStocksAvailableForItem = [];
          }
        }).catch(function (e) {
          _this.$toasted.show("Unable to load warehouse stocks available.", {
            type: "error"
          });
          throw e;
        });
      }
    },
    resetQuantitiesForOrders: function resetQuantitiesForOrders() {
      var _this$editedItem8;
      if ((_this$editedItem8 = this.editedItem) !== null && _this$editedItem8 !== void 0 && _this$editedItem8.wineId) {
        this.editedItem.quantitiesForOrders = [];
        this.isFillingOrders = false;
        this.ordersFillableForItem = [];
      }
    },
    getOrdersFillableForItem: function getOrdersFillableForItem() {
      var _this$editedItem9;
      if (!((_this$editedItem9 = this.editedItem) !== null && _this$editedItem9 !== void 0 && _this$editedItem9.wineId)) {
        this.resetQuantitiesForOrders();
      } else {
        var _this = this;
        request("/v1/purchase-orders/orders-fillable-for-wine/".concat(_this.editedItem.wineId), "get", null, true, "api").then(function (response) {
          if (response.data.value.length > 0) {
            _this.ordersFillableForItem = response.data.value;
            _this.ordersFillableForItem.forEach(function (x) {
              x._searchable_name = x.orderReference + " - " + x.quantityToFill + "btl(s) - " + getFullNameUser(x.orderUser);
            });
          } else {
            _this.ordersFillableForItem = [];
          }
        }).catch(function (e) {
          _this.$toasted.show("Unable to load orders fillable.", {
            type: "error"
          });
          throw e;
        });
      }
    },
    saveQuantitiesForOrders: function saveQuantitiesForOrders(quantitiesForOrders) {
      this.editedItem.quantitiesForOrders = quantitiesForOrders;
      this.availableFillingOrdersCanBeDbUnsynced = true;
    },
    openNewWineDialog: function openNewWineDialog() {
      this.newWineModalShown = true;
    },
    closeNewWineDialog: function closeNewWineDialog() {
      this.newWineModalShown = false;
    },
    newWineSaved: function newWineSaved(idWine) {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this11.$parent.$parent.fetchWines();
            case 2:
              _this11.newWineModalShown = false;
              _this11.dialog = true;
              _this11.assignWarehouseDefaultCountries();
              _this11.changeItem(idWine);
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    toProductDetails: function toProductDetails(item) {
      var query = {};
      return {
        name: "adminWineDetails",
        query: query,
        params: {
          id: item.wineId
        }
      };
    },
    saveReservations: function saveReservations(reservations) {
      this.editedItem.reservations = reservations;
    },
    checkOrdersFillable: function checkOrdersFillable() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!_this12.isEditingPo) {
                _context4.next = 8;
                break;
              }
              _this12.isCheckingOrdersFillable = true;
              _this = _this12;
              _context4.next = 5;
              return request("/v1/purchase-orders/".concat(_this12.dbPurchaseOrder.id, "/check-fillable"), "get", null, true, "api").catch(function (e) {
                var _e$response;
                if ((_e$response = e.response) !== null && _e$response !== void 0 && (_e$response = _e$response.data) !== null && _e$response !== void 0 && _e$response.value) _this.$toasted.show(e.response.data.value, {
                  type: "warning"
                });else _this.$toasted.show("Unable to check orders fillable.", {
                  type: "error"
                });
                _this.isCheckingOrdersFillable = false;
                throw e;
              });
            case 5:
              response = _context4.sent;
              _this12.ordersFillableResponse = response.data.value;
              _this12.isCheckingOrdersFillable = false;
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    openSupplierPrices: function openSupplierPrices(item) {
      var _this13 = this;
      this.editedItem = item;
      this.currentWineId = item.wineId;
      this.isWineSupplierPriceModalShown = true;
      this.$nextTick(function () {
        _this13.$refs.wineSupplierPriceModal.open();
      });
    },
    closeSupplierPrices: function closeSupplierPrices() {
      this.isWineSupplierPriceModalShown = false;
      this.editedItem = _objectSpread({}, this.defaultItem);
    },
    applyNewSupplierPrice: function applyNewSupplierPrice(itemSupplier, ack) {
      this.changeRate(itemSupplier.price);
      this.save();
      ack();
    },
    refreshItemList: function refreshItemList() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this14.fetchAllWinesSupplierPrices();
              _context5.next = 3;
              return _this14.fetchAllWinesStock();
            case 3:
              _this14.checkOrdersFillable();
              _this14.availableFillingOrdersCanBeDbUnsynced = false;
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    fetchAllWinesStock: function fetchAllWinesStock() {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var concurrencyLimit, items, i, batch;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              //10 by 10, to not surcharge server
              concurrencyLimit = 10;
              items = _this15.items.map(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  isStockFetched: false,
                  stockBadge: "text-danger",
                  stockTitle: ""
                });
              });
              _this15.selectedItems = items;
              i = 0;
            case 4:
              if (!(i < items.length)) {
                _context6.next = 11;
                break;
              }
              batch = items.slice(i, i + concurrencyLimit);
              _context6.next = 8;
              return Promise.all(batch.map(function (item) {
                return _this15.fetchWineStock(item);
              }));
            case 8:
              i += concurrencyLimit;
              _context6.next = 4;
              break;
            case 11:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    fetchWineStock: function fetchWineStock(item) {
      var _this16 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this, response, _item$quantitiesForOr, quantitiesForOrders, stocks;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this = _this16;
              _context7.next = 3;
              return request("/v1/stocks", "post", {
                id_wine: item.wineId
              }, true, "api", null).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to fetch stocks for product ".concat(item.wineId, "."));
                handleErrorData(_this, errorData);
              });
            case 3:
              response = _context7.sent;
              if (response) {
                item.stocks = _toConsumableArray(response.data.stocks);
                item.stocks.sort(function (a, b) {
                  if (a.stock_type.toLowerCase() != "stock" && b.stock_type.toLowerCase() == "stock") return -1;
                  if (a.stock_type.toLowerCase() == "stock" && b.stock_type.toLowerCase() != "stock") return 1;
                  return 0;
                });
                quantitiesForOrders = (_item$quantitiesForOr = item.quantitiesForOrders) === null || _item$quantitiesForOr === void 0 ? void 0 : _item$quantitiesForOr.reduce(function (acc, x) {
                  return acc + x.quantity;
                }, 0);
                item.stockTitle = "It seems there is no direct producer stock available for sales";
                if (item.stocks.length > 0) {
                  stocks = item.stocks.filter(function (x) {
                    return item.intendedCountryIds.every(function (y) {
                      return x.countries.map(function (country) {
                        return country.id_country;
                      }).includes(y);
                    });
                  });
                  if (stocks.some(function (x) {
                    return x.stock_type.toLowerCase() == "consignment" && x.quantity >= item.quantity - quantitiesForOrders;
                  })) {
                    item.stockBadge = "text-success";
                    item.stockTitle = "It seems there is sufficient direct producer stock available for sales";
                  } else if (stocks.some(function (x) {
                    return x.stock_type.toLowerCase() == "consignment" && x.quantity > 0 && x.quantity < item.quantity - quantitiesForOrders;
                  })) {
                    item.stockBadge = "text-warning";
                    item.stockTitle = "It seems there is insufficient direct producer stock available for sales";
                  } else if (stocks.some(function (x) {
                    return x.stock_type.toLowerCase() == "stock" && (_this.isStoredAtSupplier || x.reservation_type == _this.warehouse.default_stock_reservation_type && (x.reservation_type != stockReservationTypes.SPECIFIC_CUSTOMER.id || x.reservation_user_id == _this.warehouse.default_stock_reservation_user_id)) && x.quantity > (item.quantity - quantitiesForOrders) * 1.5;
                  })) {
                    item.stockBadge = "text-warning";
                    item.stockTitle = "It seems there is a warehouse stock available for sales";
                  }
                }
                item.isStockFetched = true;
              }
            case 5:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    initWineStock: function initWineStock(item) {
      var _this17 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var newItem, editedIndex;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              newItem = _objectSpread(_objectSpread({}, item), {}, {
                isStockFetched: false,
                stockBadge: "text-danger",
                stockTitle: ""
              });
              _context8.next = 3;
              return _this17.fetchWineStock(newItem);
            case 3:
              editedIndex = _this17.selectedItems.findIndex(function (x) {
                return x.wineId === item.wineId && x.sku === item.sku;
              });
              _this17.selectedItems.splice(editedIndex, 1, newItem);
              _this17.fetchAllWinesSupplierPrices();
            case 6:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    openPurchaseOrderStocksDialog: function openPurchaseOrderStocksDialog(item) {
      var _this18 = this;
      this.editedItem = item;
      this.isPurchaseOrderStocksModalShown = true;
      this.$nextTick(function () {
        _this18.$refs.purchaseOrderStocksModal.open();
      });
    },
    closePurchaseOrderStocks: function closePurchaseOrderStocks() {
      this.isPurchaseOrderStocksModalShown = false;
      this.editedItem = _objectSpread({}, this.defaultItem);
    },
    reloadPurchaseOrderStocks: function reloadPurchaseOrderStocks() {
      var _this19 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return _this19.fetchWineStock(_this19.editedItem);
            case 2:
              _this19.$nextTick(function () {
                _this19.$refs.purchaseOrderStocksModal.refresh(_this19.editedItem.stocks);
              });
            case 3:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    confirmCreateAllPreArrivalStocks: function confirmCreateAllPreArrivalStocks() {
      var _this20 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var isConfirmed;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return _this20.$refs.confirm.open("Create all pre-arrival stocks", "For each item of the purchase order, quantity that is not filling orders and not overriding default warehouse reservation, it will automatically create a new direct producer stock consolidated at the warehouse of the po, with intended countries and reservations set in the detail of po item. In case that exists a matching stock, it will add po quantity to this stock. Are you sure to proceed ?", {
                width: 650
              });
            case 2:
              isConfirmed = _context10.sent;
              if (isConfirmed) _this20.createAllPreArrivalStocks();
            case 4:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    createAllPreArrivalStocks: function createAllPreArrivalStocks() {
      var _this21 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var _this21$creatingAllPr;
        var _this;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _this21.creatingAllPreArrivalStocks.isPending = true;
              (_this21$creatingAllPr = _this21.creatingAllPreArrivalStocks.cancellationToken) === null || _this21$creatingAllPr === void 0 || _this21$creatingAllPr.cancel();
              _this21.creatingAllPreArrivalStocks.cancellationToken = axios.CancelToken.source();
              _this = _this21;
              _context11.next = 6;
              return request("/v1/purchase-orders/".concat(_this.dbPurchaseOrder.id, "/pre-arrival-stocks/"), "post", null, true, "api", null, _this.creatingAllPreArrivalStocks.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, "Unable to create all pre-arrival stocks", true);
                  handleErrorData(_this, errorData);
                }
                _this.creatingAllPreArrivalStocks.isPending = false;
                throw e;
              });
            case 6:
              _this21.creatingAllPreArrivalStocks.isPending = false;
              _this21.dbPurchaseOrder.isPreArrivalStockCreated = true;
              _this21.$toasted.show("Pre-arrival stocks created", {
                type: "success"
              });
              _context11.next = 11;
              return _this21.fetchAllWinesStock();
            case 11:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    fetchAllWinesSupplierPrices: function fetchAllWinesSupplierPrices() {
      var _this22 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var _this22$gettingSuppli;
        var wineIds, dataForSearch, paramsQuery, _this, response;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              wineIds = _toConsumableArray(_this22.selectedItems.map(function (x) {
                return x.wineId;
              }));
              _this22.gettingSupplierPrices.isPending = true;
              (_this22$gettingSuppli = _this22.gettingSupplierPrices.cancellationToken) === null || _this22$gettingSuppli === void 0 || _this22$gettingSuppli.cancel();
              _this22.gettingSupplierPrices.cancellationToken = axios.CancelToken.source();
              dataForSearch = {
                wineIds: wineIds
              };
              paramsQuery = Object.encodeToUri(dataForSearch);
              _this = _this22;
              _context12.next = 9;
              return request("/v1/suppliers/prices?params=".concat(paramsQuery), "get", null, true, "api", null, _this22.gettingSupplierPrices.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, "Unable to refresh supplier prices", true);
                  handleErrorData(_this, errorData);
                  _this.gettingSupplierPrices.isPending = false;
                  throw e;
                }
              });
            case 9:
              response = _context12.sent;
              _this22.gettingSupplierPrices.results = _toConsumableArray(response.data.value);
              _this22.gettingSupplierPrices.isPending = false;
            case 12:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    getClassSupplierPriceButton: function getClassSupplierPriceButton(item) {
      var _this23 = this,
        _this$gettingSupplier;
      var wineSupplierPrices = _toConsumableArray(this.gettingSupplierPrices.results.filter(function (x) {
        return x.wineId === item.wineId;
      }));
      var wineSupplierPricesOfSupplier = _toConsumableArray(wineSupplierPrices.filter(function (x) {
        return x.supplierId === _this23.supplierId;
      }));
      if (((_this$gettingSupplier = this.gettingSupplierPrices.results) === null || _this$gettingSupplier === void 0 ? void 0 : _this$gettingSupplier.length) === 0) {
        return "secondary";
      } else if (wineSupplierPrices.length === 0) {
        return "";
      } else if (wineSupplierPricesOfSupplier.length === 0) {
        return "danger";
      } else if (wineSupplierPricesOfSupplier.some(function (x) {
        return x.price === item.rate;
      })) {
        return "success";
      } else {
        return "warning";
      }
    },
    getInfoSupplierPriceButton: function getInfoSupplierPriceButton(item) {
      var cssClass = this.getClassSupplierPriceButton(item);
      if (cssClass == "") {
        return "loading...";
      } else if (cssClass == "") {
        return "No price for this wine";
      } else if (cssClass == "danger") {
        return "No price for this supplier, but for an other supplier";
      } else if (cssClass == "success") {
        return "Price match perfectly";
      } else {
        return "Price discrepedency";
      }
    },
    getUserList: function getUserList() {
      var _this24 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var _this24$gettingUserLi;
        var _this, response, values;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _this24.gettingUserList.results = [];
              _this24.gettingUserList.isPending = true;
              (_this24$gettingUserLi = _this24.gettingUserList.cancellationToken) === null || _this24$gettingUserLi === void 0 || _this24$gettingUserLi.cancel();
              _this24.gettingUserList.cancellationToken = axios.CancelToken.source();
              _this = _this24;
              _context13.next = 7;
              return request("/v1/third-party-users", "get", {}, true, "api").catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, "Unable to get list of available users for reservation", true);
                  handleErrorData(_this, errorData);
                  _this.gettingUserList.isPending = false;
                }
                throw e;
              });
            case 7:
              response = _context13.sent;
              values = _toConsumableArray(response.data.value);
              values.forEach(function (user) {
                var _listUserGroups$find;
                var fullName = getFullNameUser(user) + " - " + user.delivery_address.country.iso_code + " " + ((_listUserGroups$find = listUserGroups.find(function (x) {
                  return x.id === user.user_group.toUpperCase();
                })) === null || _listUserGroups$find === void 0 ? void 0 : _listUserGroups$find.name) + " (" + user.login + ")";
                _this24.gettingUserList.results.push(_objectSpread(_objectSpread({}, user), {}, {
                  full_name: fullName
                }));
              });
              _this24.gettingUserList.results.sort(function (a, b) {
                return a.full_name.localeCompare(b.full_name);
              });
              _this24.gettingUserList.isPending = false;
            case 12:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    getConsultantList: function getConsultantList() {
      var _this25 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var _this25$gettingConsul;
        var data, _this, response;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _this25.gettingConsultantList.isPending = true;
              (_this25$gettingConsul = _this25.gettingConsultantList.cancellationToken) === null || _this25$gettingConsul === void 0 || _this25$gettingConsul.cancel();
              _this25.gettingConsultantList.cancellationToken = axios.CancelToken.source();
              data = {
                isHolding: true,
                active: true
              };
              _this = _this25;
              _context14.next = 7;
              return request("/v1/users", "post", data, true, "api", null, _this.gettingConsultantList.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, "Unable to get list of available consultants for reservation", true);
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 7:
              response = _context14.sent;
              response.data.users.forEach(function (user) {
                _this25.gettingConsultantList.results.push({
                  id: user.id_user,
                  full_name: getFullNameUser(user) + " - " + user.delivery_country_iso_code + " - " + user.consultant_code + " (" + user.login + ")"
                });
              });
              _this25.gettingConsultantList.results.sort(function (a, b) {
                return a.full_name.localeCompare(b.full_name);
              });
              _this25.gettingConsultantList.isPending = false;
            case 11:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }))();
    },
    getLabelReservation: function getLabelReservation(stock) {
      if (stock.reservation_type === stockReservationTypes.SPECIFIC_CUSTOMER.id) {
        return getFullNameUser(stock.reservation_user);
      } else if (stock.reservation_type === stockReservationTypes.SPECIFIC_CONSULTANT.id) {
        return getFullNameUser(stock.reservation_consultant);
      } else {
        return Object.values(stockReservationTypes).find(function (x) {
          return x.id === stock.reservation_type;
        }).name;
      }
    },
    filterVAutocomplete: filterVAutocomplete,
    formatPrice: formatPrice
  },
  watch: {
    dialog: function dialog(val) {
      val || this.close();
    },
    dialogDelete: function dialogDelete(val) {
      val || this.closeDelete();
    }
  }
};